<script>
	import BuildBox from './build-box.svelte';

	let endpoint = location.hostname !== "localhost"
		? "release-data.json"
		: "http://localhost/release-data.json";

	let data = {};

	async function refresh () {
		console.log('Requesting data...');
		data = await fetch(endpoint, { cache: 'no-cache' }).then( d => d.json() );

		['omaha', 'github'].forEach( store => {
			for ( let channel in data[store].channels ) {
				data[store].channels[channel].sort(
					(a, b) => a.date < b.date ? 1 : -1
				)
			}
		});

		setTimeout(refresh, 1000 * 60 * 10);
	}

	refresh();

</script>

<main>
	<BuildBox {data}></BuildBox>
</main>